<template>
  <DbReservationSummary
    :isLoading="isCartSummaryLoading"
    :cartSummary="cartSummary"
    showEditionOptions
    :allow-addons-edition="route.name !== 'package-configuration'"
    :packageData="currentPackage?.galaxyPackage"
    v-on:delete-addons="deleteAddons"
    v-on:start-over="startOver"
    v-on:edit-room="editRoom"
    v-on:edit-addons="editAddons"
  />
</template>

<script lang="ts" setup>
import { useCartStore } from '@/stores/cart'
import { storeToRefs } from 'pinia'
import { useFunnelRouter } from '@/AppBookingFunnel/composables/funnel-router'
import { useRoute } from 'vue-router'
import { useGtm } from '@/composables/features/useGtm'
import { usePackagesStore } from '@/stores/packages'
import { useModalsStore } from '@/stores/modals'
import { useI18n } from 'vue-i18n'
const { event, eventData } = useGtm()

const route = useRoute()

const cartStore = useCartStore()
const { cartSummary, isCartSummaryLoading, currentPackage } = storeToRefs(cartStore)

const funnelRouter = useFunnelRouter()

const modalStore = useModalsStore()

const { t } = useI18n()

function startOver() {
  eventData('start_over', { event_source: 'gaEventDelphiDirect' })
  funnelRouter.goToPackageSelection()
}

function editRoom() {
  eventData('edit_room', { event_source: 'gaEventDelphiDirect' })
  funnelRouter.goToPackageSelection()
}

function editAddons() {
  funnelRouter.goToPackageConfiguration()
}

async function deleteAddons() {
  const packagesStore = usePackagesStore()
  const hotel = window.db2BookingFunnel.getHotel()
  let attendees_bucket = ''
  if (packagesStore.attendees >= 0 && packagesStore.attendees <= 5) attendees_bucket = '0-5'
  if (packagesStore.attendees >= 6 && packagesStore.attendees <= 10) attendees_bucket = '6-10'
  if (packagesStore.attendees >= 11 && packagesStore.attendees <= 20) attendees_bucket = '11-20'
  if (packagesStore.attendees >= 21 && packagesStore.attendees <= 30) attendees_bucket = '21-30'
  if (packagesStore.attendees > 30) attendees_bucket = '+30'

  // Ask confirmation for clear all the addOns
  const response = await modalStore.confirm({
    title: t('Are you sure?'),
    body: t('This action will clear all your add-ons from the cart'),
    confirmButton: t('Yes, clear it'),
    cancelButton: t('No, keep it'),
  })
  // Do nothing is the modal response is "no"
  if (!response) {
    return
  }

  cartSummary.value?.addons.forEach((addon) => {
    event('remove_from_cart', {
      currency: cartSummary.value?.currencyCode,
      items: {
        item_id: addon.addOnID,
        item_name: addon.name,
        affiliation: hotel?.name,
        index: 0,
        item_brand: hotel?.master_item?.name,
        item_category: 'meeting rooms addons',
        item_list_id: 'addons_list',
        item_list_name: 'Addons List',
        item_variant: '',
        attendees_bucket: attendees_bucket,
        quantity: 1,
      },
    })
  })
  cartStore.setAddons({})
}
</script>
